import { ApolloError } from "@apollo/client";
import { GraphQLError } from "graphql";

type UnknownError = ApolloError | GraphQLError | null | undefined;

const hasItem = (item: any) => Array.isArray(item) && item.length > 0;

export function getFirstGraphqlError(error: UnknownError) {
  if (!(error instanceof ApolloError)) {
    return;
  }

  const [firstError] = error.graphQLErrors;

  if (!firstError) {
    return;
  }

  const errors = (firstError.extensions?.exception as any)?.errors;
  if (hasItem(errors)) {
    return errors[0] || "";
  }

  // The server returned an error description in the body
  const bodyErrors = (firstError.extensions?.response as any)?.body?.errors;
  if (hasItem(bodyErrors)) {
    return bodyErrors[0] || "";
  }

  return firstError.message || "";
}

export function getNetworkError(error: UnknownError) {
  if (!(error instanceof ApolloError)) {
    return;
  }

  const networkError = error.networkError?.message;

  if (networkError) {
    return `Network error: ${networkError}`;
  }
}

export function getErrorMessage(error: UnknownError) {
  if (!error) return "";

  const message =
    // Show graphql errors first
    getFirstGraphqlError(error) ||
    // This will catch generic network errors
    getNetworkError(error) ||
    // Fallback to graphql error stringification
    error.toString() ||
    "";

  return message?.message || message;
}
